// @flow

import React from 'react';
import { observer } from 'mobx-react';
import { observable, computed, action } from 'mobx';
import { gql, graphql } from 'react-apollo';

import PlatformMain from '~/components/content/platform/PlatformMain';
import UIStore from '~/stores/ui-store';
import type {
    User as UserType,
    Company as CompanyType,
    Genre as GenreType,
    SelectOption,
} from '~/types';

const PlatformMainWithData = graphql(
    gql`
    query Platform(
            $state: String,
            $text: String,
            $platform: String,
            $year: Int,
            $letter: String,
            $genre: String,
            $developer: String,
            $author: String,
            $slug: String
        ) {
            reviews(
                state: $state,
                text: $text,
                platform: $platform,
                author: $author,
                year: $year,
                letter: $letter,
                genre: $genre,
                developer: $developer
            ) {
                id,
                name,
                slug,
                version,
                publishedAt,
                content {
                    brief {
                        md
                    }
                }
                author {
                    name,
                    slug,
                    avatar {
                        secure_url
                    }
                },
                game {
                    name,
                    genres {
                        id,
                        name,
                        image {
                            secure_url
                        },
                        slug
                    },
                    releaseDates {
                        jp,
                        us,
                        eu,
                        aes,
                        mvs
                    },
                    thumbnail {
                        secure_url
                    },
                    image {
                        secure_url
                    },
                    developer {
                        name
                    },
                }
            },
             developers: companies {
                    id,
                    name
                },
                authors: users {
                    id,
                    name,
                    avatar {
                        secure_url
                    },
                },
                genres {
                    id,
                    name,
                    image {
                        secure_url
                    },
                    slug
                },
                 platforms(slug: $slug) {
                    id,
                    name,
                    slug,
                    releaseDates {
                        jp,
                        us,
                        eu
                    },
                    image {
                        secure_url
                    },
                    backgroundImage {
                        secure_url
                    },
                    japanese,
                    maker {
                        name
                    },
                    controller,
                    discontinuationDates {
                        jp,
                        us,
                        eu
                    },
                    media,
                    totalSales,
                    content {
                        brief {
                            md
                        }
                    }
                },
                 developers: companies {
                    id,
                    name
                },
                authors: users {
                    id,
                    name,
                    avatar {
                        secure_url
                    },
                },
                genres {
                    id,
                    name,
                    image {
                        secure_url
                    },
                    slug
                },
                 platforms(slug: $slug) {
                    id,
                    name,
                    slug,
                    releaseDates {
                        jp,
                        us,
                        eu
                    },
                    image {
                        secure_url
                    },
                    backgroundImage {
                        secure_url
                    },
                    japanese,
                    maker {
                        name
                    },
                    controller,
                    discontinuationDates {
                        jp,
                        us,
                        eu
                    },
                    media,
                    totalSales,
                    content {
                        brief {
                            md
                        }
                    }
                }
    }`,
    {
        options: props => ({
            variables: {
                ...props.query,
                slug: props.params.slug,
            },
        }),
        props: ({
            data: {
                reviews,
                developers,
                authors,
                genres,
                platforms: [platform] = [],
                loading,
            },
        }) => {
            UIStore.setIsLoading(loading);

            return {
                reviews,
                developers,
                authors,
                genres,
                platform,
            };
        },
    }
)(PlatformMain);

@observer
export default class PlatformMainContainer extends React.Component {
    constructor() {
        super();

        this.handleLetterSearch = this.handleLetterSearch.bind(this);
        this.handleToggleMoreCriteria = this.handleToggleMoreCriteria.bind(
            this
        );
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleLetterSearch: Function;
    handleToggleMoreCriteria: Function;
    handleInputChange: Function;

    @observable text: string;
    @observable developer: CompanyType;
    @observable genre: GenreType;
    @observable year: SelectOption;
    @observable author: UserType;
    @observable letter: string;
    @computed get query(): Object {
        return {
            state: 'published',
            text: this.text,
            developer: this.developer && this.developer.id,
            genre: this.genre && this.genre.id,
            year: this.year && this.year.value,
            author: this.author && this.author.id,
            letter: this.letter,
        };
    }

    @observable moreCriteriaVisible: boolean;

    @action handleLetterSearch(letter: string) {
        this.letter = this.letter === letter ? '' : letter;
    }

    @action handleToggleMoreCriteria() {
        this.moreCriteriaVisible = !this.moreCriteriaVisible;
    }

    @action handleInputChange(name: string, value: any) {
        this[name] = value || undefined;
    }

    render() {
        return (
            <PlatformMainWithData
                author={ this.author }
                developer={ this.developer }
                genre={ this.genre }
                onInputChange={ this.handleInputChange }
                onLetterClick={ this.handleLetterSearch }
                onToggleMoreCriteria={ this.handleToggleMoreCriteria }
                query={ this.query }
                selectedLetter={ this.letter }
                moreCriteriaVisible={ this.moreCriteriaVisible }
                year={ this.year }
                { ...this.props }
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/content/platform/PlatformMainContainer.js